//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import {
  CatalogConstants,
  ExportPackageModel,
  ExportPackageRequest,
  PackageExportErrorMessage,
  PackageExportQueuedMessage,
  ProjectHttpService,
  SelectOptionMessage,
} from "@app/catalog";
import { ToastLevel, ToastMessage } from "@app/components";
import { CloseDialogMessage, CommandModel, Messenger, PresenterType } from "@app/shared";

@PresenterType({
  model: ExportPackageModel,
})
@Component({
  selector: "export-project",
  standalone: false,
  templateUrl: "./export.component.html",
  styleUrl: "./export.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportComponent implements OnDestroy {

  public readonly FIELDS = CatalogConstants.CHECKBOX_FIELDS;

  public serviceMatrix = signal(false);
  public roomSummary = signal(false);
  public applicableStandards = signal(false);
  public associatedDocuments = signal(false);
  public revitModels = signal(false);

  public data: WritableSignal<ExportPackageModel> = signal<ExportPackageModel>(null);

  constructor(
    private messenger: Messenger,
    private projectHttpService: ProjectHttpService
  ) {}


  public onChecked(event: any, field: string) {
    switch (field) {
      case this.FIELDS.SERVICE_MATRIX:
        this.serviceMatrix.set(event.target.checked);
        break;
      case this.FIELDS.ROOM_SUMMARY:
        this.roomSummary.set(event.target.checked);
        break;
      case this.FIELDS.REVIT_MODELS:
        this.revitModels.set(event.target.checked);
        break;
      case this.FIELDS.ASSOCIATED_DOCUMENTS:
        this.associatedDocuments.set(event.target.checked);
        break;
      case this.FIELDS.APPLICABLE_STANDARDS:
        this.applicableStandards.set(event.target.checked);
        break;
    }
  }

  public cancelCommand = new CommandModel({
    executeAction: () => {
      this.messenger.send(new CloseDialogMessage());
      return Promise.resolve();
    },
  });

  public exportCommand = new CommandModel({
    executeAction: () => this.onExport(),
    isValid: signal(false),
  });

  private onExport = async () => {
    console.log('Export Options:', {
      serviceMatrix: this.serviceMatrix(),
      roomSummary: this.roomSummary(),
      applicableStandards: this.applicableStandards(),
      associatedDocuments: this.associatedDocuments()
    });

    if (!this.serviceMatrix() && !this.roomSummary() && !this.associatedDocuments() && !this.applicableStandards()) {
      this.messenger.send(ToastMessage.create(new SelectOptionMessage(),ToastLevel.Warning));
      return;
    }

    const request = new ExportPackageRequest();
    request.id = this.data().project.id;
    request.referenceType = 2;
    request.pageSize = 1;
    request.leftMarginInches = 0.5;
    request.roomSystemsMatrix = this.serviceMatrix();
    request.roomSummarySheets = this.roomSummary();
    request.applicableStandards = this.applicableStandards();
    request.associatedDocuments = this.associatedDocuments();

    try {
      const result = await this.projectHttpService.exportPackage(request);
      await result.response;
      this.messenger.send(new CloseDialogMessage());
      this.messenger.send(ToastMessage.create(new PackageExportQueuedMessage(),ToastLevel.Success));
    } catch (error) {
      console.error(error);
      this.messenger.send(ToastMessage.create(new PackageExportErrorMessage(),ToastLevel.Warning));
    }

  };

  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
  }
}
